import React from "react";
import { getUser } from "../../services/user-service";
import UserBase from "../../components/user/UserBase";
import BeneficiryBase from "../../components/beneficiary/BeneficiaryBase";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import OrganizationBase from "../organization/OrganizationBase";
import WhyIchest from "../../pages/whyIChest/whyIChest";
function WhyIchestRoute() {
  let role = getUser().role;
  if (role === "USER" || role === "ORG_USER") {
    return (
      <UserBase>
        <WhyIchest/>
      </UserBase>
    );
  } else if (role === "BENEFICIARY") {
    return (
      <BeneficiryBase>
        <WhyIchest/>
      </BeneficiryBase>
    );
  } else if (role === "ATTORNEY") {
    return (
      <TrusteeBase>
        <WhyIchest/>
      </TrusteeBase>
    );
  }else if (role === "TENANT_ADMIN" || role === "TENANT_USER"){
    return (
      <OrganizationBase>
        <WhyIchest />
      </OrganizationBase>
    );
}
}
export default WhyIchestRoute;
